export default __webpack_public_path__ + "media/images/features/yado/right_loop-a7831e99d89bea08c48061a3cba63f23.png";